import {
  ColorsNeutral200,
  ColorsNeutral500,
  ColorsPrimary900,
  Dimensions1,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const menuPaperProps = css({
  '&.MuiPaper-root': {
    maxHeight: '80vh',
    width: '100%',
    maxWidth: '500px',
    '& .MuiList-root': {
      padding: Dimensions1,
    },
  },
});

const menuItem = css({
  '&:hover': {
    backgroundColor: ColorsNeutral200,
  },
});

const menuItemLabel = css({
  '&.MuiTypography-root': {
    color: ColorsPrimary900,
  },
});

const menuItemDescription = css({
  '&.MuiTypography-root': {
    textWrap: 'pretty',
    color: ColorsNeutral500,
  },
});

const RoleSelectorStyles = {
  menuPaperProps,
  menuItem,
  menuItemLabel,
  menuItemDescription,
};

export default RoleSelectorStyles;
